import { useRequest } from 'ahooks'

import { setDefaultBankApi } from '@eastcoal/api/finance/bank/setDefaultBank'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { MEMBER_MANAGE_ACTION_UUID } from '../../../../../constants/uuid'
import { useMemberBankListStore } from '../../../Store/hooks/useStore'

import { MemberBankSetDefaultButtonProps } from './interface'

export const MemberBankSetDefaultButton = ({
  record: { id, defaultBank }
}: MemberBankSetDefaultButtonProps) => {
  const { tableRef } = useMemberBankListStore(state =>
    pick(state, ['tableRef'])
  )
  const { message } = useFeedback()
  const { refreshAsync } = useRequest(() => setDefaultBankApi({ id }), {
    manual: true,
    onSuccess: () => {
      message.success('设置默认银行卡成功')
      tableRef.current?.reload()
    }
  })

  return defaultBank ? null : (
    <ConfirmButton
      message='确定设置为默认银行卡吗？'
      type='link'
      uuid={MEMBER_MANAGE_ACTION_UUID}
      onConfirm={refreshAsync}
    >
      设为默认
    </ConfirmButton>
  )
}
